import { render, staticRenderFns } from "./MuseumsCard.vue?vue&type=template&id=5c457c38&scoped=true&"
import script from "./MuseumsCard.vue?vue&type=script&lang=js&"
export * from "./MuseumsCard.vue?vue&type=script&lang=js&"
import style0 from "./MuseumsCard.vue?vue&type=style&index=0&id=5c457c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c457c38",
  null
  
)

export default component.exports